import React from 'react';
import PropTypes from 'prop-types';
import '../../sass/modules/_modalNotifi.scss'

const ModalNotificationToken = ({ children }) => (
  <div className="ui--modal-notifications active">
    <div>
      <section style={{ borderRadius: '10px',}}>
        {children}
        {/* <a className="close" onClick={toggle}>{xclose}</a> */}
      </section>
    </div>
  </div>
);

ModalNotificationToken.propTypes = {
  children: PropTypes.node.isRequired,
};

export default (ModalNotificationToken);
